import { showNotification } from "@mantine/notifications";

/**
 * Attempts to parse field containing a floating point number.
 * @param value The value to parse.
 */
export const parseNumberFieldValue = (
  value: number | string
): number | undefined => {
  let numericValue: number | undefined;

  if (typeof value === "string") {
    const trimmed = value.trim();
    numericValue = trimmed === "" ? undefined : parseFloat(trimmed);
  } else {
    numericValue = value;
  }

  return numericValue;
};

export const showFieldError = (error: any, fieldName: string) => {
  // Attempt to extract the custom backend error message
  const serverMessage =
    error?.response?.data?.content?.message ||
    `An error occurred while updating the field "${fieldName}".`;
  showNotification({
    title: "Error",
    message: serverMessage,
    color: "red",
  });
};
